import { render, staticRenderFns } from "./IDL.vue?vue&type=template&id=42c3b178&scoped=true"
import script from "./IDL.vue?vue&type=script&lang=js"
export * from "./IDL.vue?vue&type=script&lang=js"
import style0 from "./IDL.vue?vue&type=style&index=0&id=42c3b178&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3b178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c3b178')) {
      api.createRecord('42c3b178', component.options)
    } else {
      api.reload('42c3b178', component.options)
    }
    module.hot.accept("./IDL.vue?vue&type=template&id=42c3b178&scoped=true", function () {
      api.rerender('42c3b178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/CandidateData/PersonnelInformation/IDL.vue"
export default component.exports